import styled from 'styled-components';

import { primitive } from 'styles/constants/primitives';

export const IconContainer = styled.button`
  border: none;
  display: inline;
  background: transparent;
  cursor: pointer;
`;

export const Cart = styled.div`
  font-style: normal;
  font-size: 0.9375rem;
  font-family: ${Styles.fontFamily.body};
`;

export const RewardsPointsContainer = styled.div`
  margin: 0 ${primitive.$spacing6};
`;
